import Helpers from './helpers';
import FormHelpers from './form-helpers';
import ApiHelpers from './api-helper';

const SignUpFlow = {
	init() {
		this.currentTab = 0;
		this.tabs = document.getElementsByClassName('tab');
		this.nextBtn = document.getElementById('nextBtn');
		this.subtitle = document.getElementById('subtitle');
		this.btnTextInitial = this.nextBtn?.dataset?.btnTextInitial;
		this.btnTextFinal = this.nextBtn?.dataset?.btnTextFinal;
		this.subtitleStep2 = this.subtitle?.dataset?.subtitleStepTwo;
		this.form = document.getElementById('signUpForm');
		if (this.tabs != null && this.tabs.length > 0 && this.nextBtn != null) {
			this.showTab();
			this.initEvents();
		}
		this.errorMessages = [];
	},

	initEvents() {
		this.nextBtn.addEventListener('click', (e) => {
			this.handleNext(e);
		});

		this.form?.addEventListener('keypress', (e) => {
			if (e.key === 'Enter') {
				this.handleNext(e);
			}
		});
	},

	handleNext(e) {
		e.preventDefault();

		if (!FormHelpers.validateFormByTab(this.errorMessages, this.tabs[this.currentTab])) {
			Helpers.enableAllButtons();
			return false;
		}

		if (this.currentTab === 0) {
			this.checkEmail();
		} else {
			this.nextStep(1);
		}
	},

	checkEmail() {
		const emailItem = document.getElementById('emailAddress');
		const email = emailItem?.value;
		const antiForgeryToken = emailItem?.dataset?.antiForgeryToken;
		ApiHelpers.post(
			'professionalApi/CheckEmail',
			{ email },
			(response) => this.handleEmailCheckResponse(response),
			null,
			antiForgeryToken
		);
	},

	handleEmailCheckResponse(responseContent) {
		if (responseContent?.redirectUrl && responseContent.redirectUrl.trim() !== '') {
			window.location.href = responseContent.redirectUrl;
		} else {
			this.nextStep(1);
		}
	},

	showTab() {
		const hash = this.tabs[this.currentTab]?.dataset?.url;
		if (hash) window.history.replaceState(null, null, `#${hash}`);
		this.tabs[this.currentTab].style.display = 'block';
		Helpers.scrollTo(300);
		if (this.currentTab === this.tabs.length - 1) {
			this.nextBtn.innerHTML = this.btnTextFinal;
			if (this.subtitle) {
				this.subtitle.innerHTML = this.subtitleStep2;
			}
		} else {
			this.nextBtn.innerHTML = this.btnTextInitial;
		}
	},

	nextStep(n) {
		Helpers.disableAllButtons();

		// This function will figure out which tab to display
		// Exit the function if any field in the current tab is invalid:
		if (n === 1 && !FormHelpers.validateFormByTab(this.errorMessages, this.tabs[this.currentTab])) {
			Helpers.enableAllButtons();
			return false;
		}
		// Hide the current tab:
		if (this.currentTab + 1 < this.tabs.length || n === -1) {
			this.tabs[this.currentTab].style.display = 'none';
		}
		// Increase or decrease the current tab by 1:
		this.currentTab += n;
		// if you have reached the end of the form... :
		if (this.currentTab >= this.tabs.length) {
			// ...the form gets submitted:
			Helpers.addHiddenIdField(this.form);
			this.form.submit();
			return false;
		}
		// Otherwise, display the correct tab:
		this.showTab(this.currentTab);
		Helpers.enableAllButtons();
		return false;
	},
};

export { SignUpFlow as default };
